import styled from '@emotion/styled';
import { Row } from '../../../../ui';

export const AuthFormRow = styled(Row)``;

AuthFormRow.defaultProps = {
	columns: 1,
};
